import { render, staticRenderFns } from "./ArticleCatalogPopup.vue?vue&type=template&id=9411bb2a&scoped=true&"
import script from "./ArticleCatalogPopup.vue?vue&type=script&lang=ts&"
export * from "./ArticleCatalogPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleCatalogPopup.vue?vue&type=style&index=0&id=9411bb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9411bb2a",
  null
  
)

export default component.exports